import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { returnSubmit } from "../../../../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../../../../contexts/Snackbar";
import { SPECIES_BOOKING_MODAL } from "../../../../../../enums/QueryKeys";

export default function useClinicSpeciesPut(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    mutate(obj);
  };

  function updateKey(key, newData) {
    const updatedEntity = newData;
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData; // If no old data, return as is

      const newSpecies = updatedEntity.speciesIds.map((val) => Number(val));
      const clinicsSpecies =
        oldData?.species?.filter((s) => newSpecies.includes(s.id)) ?? [];
      const updatedObject = {
        species: oldData?.species ?? [],
        allowsAllSpecies: updatedEntity?.allSpeciesAllowed ?? true,
        clinics: clinicsSpecies,
      };
      return updatedObject;
    });
  }

  const { mutate } = useMutation({
    mutationFn: async (data) => {
      await returnSubmit(url, data);
      return data; // Return the input data instead of response.data
    },
    onSuccess: (data) => {
      updateKey(queryKey, data);
      // the new-pet dropdowns list the clinic's species too
      queryClient.invalidateQueries([SPECIES_BOOKING_MODAL]);
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
